// TODO: Replace with gradient from the design system when available
export const GREEN_GRADIENT = 'linear-gradient(84.11deg, #02BE7B -81.67%, #0FAA8F 107.96%)';
